<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link :to="{ path: '/requisicao', query: this.$route.query }">
        Compras/Requisição/Requisição
      </router-link>
      <label class="labelBar"> / </label>
      <label> Aprovar Requisição </label>
    </div>
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Unidade Administrativa"
              v-model="unidadeAdm"
              :counter="200"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Local de Entrega"
              v-model="local"
              :counter="200"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Requisitante"
              v-model="requisitante"
              :counter="200"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Prioridade"
              v-model="prioridade"
              :counter="200"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Nº Requisição"
              v-model="requisicao.nome"
              :counter="200"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-textarea
              label="Observação"
              auto-grow
              v-model="observacao" v-uppercase
              rows="1"
              readonly
            ></v-textarea>
          </v-col>
          <v-col cols="12" sm="6">
            <v-textarea
              label="Observação do Aprovador"
              auto-grow
              v-model="observacaoAprovador"
              maxlength="200"
              counter
              rows="1"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-snackbar v-model="errorMessage" color="error" timeout="5000"
          >{{ errorMessageValue }}
        </v-snackbar>
      </v-form>
      <v-card>
        <v-data-table :headers="headers" hide-default-footer :items-per-page="-1" :items="produtosL">
          <template v-slot:item.autorizado="{ item }">
            {{ item.quantidadeAprovada > 0 ? "Sim" : "Não" }}
          </template>
          <template v-slot:item.quantidadeAprovada="{ item }">
            <v-text-field
              v-model="item.quantidadeAprovada"
              type="number"
              v-mask="['#####']"
              :rules="[
                (v) =>
                  (!!v && v >= 0 && v <= item.quantidade) ||
                  'A quantidade deve ser 0 até a quantidade requisitada!',
              ]"
              required
            >
            </v-text-field>
          </template>
        </v-data-table>
      </v-card>

      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn
            @click="desfazer"
            color="primary"
            class="mr-4"
            :disabled="requisicao.status != 'PA'"
          >
            Desaprovar
          </v-btn>
          <v-btn
            @click="declinar"
            :disabled="(requisicao.status == 7 && !isAdmin()) || !isInactive(idModulo)"
            color="secondary"
            class="mr-4"
          >
            Declinar
          </v-btn>
          <v-btn
            :to="{ path: '/requisicao', query: $route.query }"
            color="error"
            class="mr-4"
          >
            Voltar
          </v-btn>
          <v-btn
            @click="aprovar"
            color="success"
            class="mr-4"
            :disabled="requisicao.status != 'AA' || !isApproving(idModulo)"
          >
            Aprovar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import {
  aprovarRequisicaoAsync,
  declinarRequisicaoAsync,
  desautorizarRequisicaoAsync,
} from "../../../services/requisicaoService";
import { mapState, mapActions } from "vuex";
import {
  canApproveModule,
  canDeclineModule,
  getUserRoles,
  isLoggedUserAdmin,
  logApprovalDiagnostics,
  explainApprovalButtonState,
} from "@/services/loginService";

export default {
  name: "aprovarRequisicao",
  data: () => ({
    idModulo: 8,
    prioridade: null,
    overlay: false,
    valid: true,
    id: null,
    requisitante: null,
    idOrdemServico: null,
    descricao: null,
    observacao: null,
    observacaoAprovador: null,
    autorizado: null,
    local: null,
    unidadeAdm: null,
    produtosL: [],
    indexEdit: null,
    errorMessage: false,
    errorMessageValue: null,
    headers: [
      { text: "ID", value: "id", sortable: false },
      { text: "Item", value: "descricao", sortable: false },
      { text: "Cod. Fabricante", value: "codigo", sortable: false },
      { text: "Qtd.", value: "quantidade", sortable: false },
      { text: "Und.", value: "unidadeMedida", sortable: false },
      {
        text: "Qtd. Aprv.",
        value: "quantidadeAprovada",
        width: "10%",
      },
      { text: "Aprov.?", value: "autorizado", sortable: false },
      { text: "Centro de Custo", value: "centroCusto", sortable: false },
      { text: "Detalhamento", value: "observacao", sortable: false },
      { text: "", value: "actions", sortable: false },
    ],
  }),
  computed: {
    ...mapState("requisicao", ["requisicao"]),
  },
  methods: {
    ...mapActions("requisicao", ["updateRequisicao"]),
    isApproving(id) {
      const pode = canApproveModule(id);
      logApprovalDiagnostics("Requisicao/Aprovar:Aprovar", explainApprovalButtonState({
        modulo: id,
        registro: this.requisicao,
        action: "aprovar",
        statusPermitidos: ["AA"],
      }));
      return pode;
    },
    isInactive(id) {
      const pode = canDeclineModule(id);
      logApprovalDiagnostics("Requisicao/Aprovar:Declinar", explainApprovalButtonState({
        modulo: id,
        registro: this.requisicao,
        action: "declinar",
        statusPermitidos: ["AA", "PA", "D"],
      }));
      return pode;
    },
    isAdmin() {
      return isLoggedUserAdmin();
    },
    async aprovar() {
      if (this.overlay) {
        return;
      }

      const produtosNormalizados = this.normalizarProdutosParaAprovacao();

      if (this.$refs.form.validate()) {
        if (produtosNormalizados.length === 0) {
          this.errorMessageValue =
            "A requisição não possui itens para aprovação.";
          this.errorMessage = true;
          return;
        }

        this.errorMessage = false;
        for (let i = 0; i < produtosNormalizados.length; i++) {
          if (
            !Number.isInteger(produtosNormalizados[i].quantidadeAprovada) ||
            produtosNormalizados[i].quantidade <
              produtosNormalizados[i].quantidadeAprovada ||
            produtosNormalizados[i].quantidadeAprovada < 0
          ) {
            this.errorMessageValue =
              "A quantidade deve ser entre 0 até a mesma quantidade requisitada!";
            this.errorMessage = true;
            break;
          }
        }
        //if ( this.produtosL.filter((p) => {
        //    return p.quantidadeAprovada > 0;
        //  }).length == 0 && !this.errorMessage )
        //  {
        //  this.errorMessageValue = "Gentileza alterar a quantidade de itens que estão sendo aprovados!";
        //  this.errorMessage = true;
        //}
        if (this.errorMessage) {
          return;
        }
        this.errorMessage = true;
        this.errorMessageValue =
          "A quantidade de pelo menos 1 dos items deve ser maior que zero!";
        for (let i = 0; i < produtosNormalizados.length; i++) {
          if (produtosNormalizados[i].quantidadeAprovada > 0) {
            this.errorMessage = false;
            break;
          }
        }
        if (this.errorMessage) {
          return;
        }
        this.overlay = true;
        try {
          const resposta = await aprovarRequisicaoAsync(
            this.requisicao.id,
            this.observacaoAprovador,
            produtosNormalizados
          );
          if (!resposta || resposta?.status != 200) {
            //this.mensagemErro = resposta;
            //this.mostartMensagemErro = true;
            this.$alert(
              resposta.message,
              "Desculpe, falha na operação!",
              "error"
            );
          } else {
            this.updateRequisicao(this.mountObjRequisicao(resposta.data));
            this.$store.dispatch("ui/showSnackbar", {
              text: "Requisição aprovada!",
              color: "success",
              timeout: 3000,
            });
            this.$router.push({
              path: "/requisicao",
              query: this.$route.query,
            });
          }
        } finally {
          this.overlay = false;
        }
      }
      /*if (this.produtosL == null || this.produtosL.length <= 0) {
        this.errorMessage = true;
      } else if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await aprovarRequisicaoAsync(
          this.requisicao.id
        );
        if (resposta) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$router.push("/requisicao");
        }
      }*/
    },

    async declinar() {
      try {
        await this.$confirm(
          "Tem certeza que deseja declinar os itens? Todos serão cancelados.",
          "Confirmação",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Não",
            type: "warning",
          }
        );
        this.overlay = true;
        try {
          const resposta = await declinarRequisicaoAsync(
            this.requisicao.id,
            this.observacaoAprovador
          );
          if (!resposta || resposta?.status != 200) {
            //this.mensagemErro = resposta;
            //this.mostartMensagemErro = true;
            this.$alert(
              resposta.message,
              "Descupe, falha na operação!",
              "error"
            );
          } else {
            this.updateRequisicao(this.mountObjRequisicao(null));
            this.$store.dispatch("ui/showSnackbar", {
              text: "Requisição declinada!",
              color: "success",
              timeout: 3000,
            });
            this.$router.push({
              path: "/requisicao",
              query: this.$route.query,
            });
          }
        } finally {
          this.overlay = false;
        }
      } catch (e) {
        // O cancelamento da confirmação não exige ação adicional.
        // eslint-disable-next-line no-console
        console.log("Cancelado pelo usuário");
      }
    },
    async desfazer() {
      try {
        await this.$confirm(
          "Tem certeza que deseja desaprovar os itens? Os mesmos voltaram para o status inicial de “Aguardando autorização”.",
          "Confirmação",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Não",
            type: "warning",
          }
        );
        for (var i = 0; i < this.produtosL.length; i++) {
          this.produtosL[i].quantidadeAprovada = 0;
        }
        this.observacaoAprovador = null;
        this.overlay = true;
        try {
          const resposta = await desautorizarRequisicaoAsync(
            this.requisicao.id,
            this.observacaoAprovador,
            this.produtosL
          );
          if (!resposta || resposta?.status != 200) {
            this.$alert(
              resposta.message,
              "Desculpe, falha na operação!",
              "error"
            );
          } else {
            this.updateRequisicao(this.mountObjRequisicao(resposta.data));
            this.$store.dispatch("ui/showSnackbar", {
              text: "Requisição desautorizada!",
              color: "success",
              timeout: 3000,
            });
            this.$router.push({
              path: "/requisicao",
              query: this.$route.query,
            });
          }
        } finally {
          this.overlay = false;
        }
      } catch (e) {
        // O cancelamento da confirmação não exige ação adicional.
        // eslint-disable-next-line no-console
        console.log("Cancelado pelo usuário");
      }
    },

    mountObjRequisicao(obj) {
      return {
        ...this.requisicao,
        status: obj == null ? "D" : obj.status,
        produtos: this.produtosL,
        observacaoAutorizador: this.observacaoAprovador,
      };
    },
    normalizarProdutosParaAprovacao() {
      return (this.produtosL || []).map((item) => {
        const valorAtual = item.quantidadeAprovada;
        const semValor =
          valorAtual === null ||
          valorAtual === undefined ||
          (typeof valorAtual === "string" && valorAtual.trim() === "");
        const quantidadeAprovada = semValor
          ? Number(item.quantidade)
          : Number(valorAtual);

        this.$set(item, "quantidadeAprovada", quantidadeAprovada);
        this.$set(item, "autorizado", quantidadeAprovada > 0);

        return {
          ...item,
          quantidade: Number(item.quantidade),
          quantidadeAprovada,
          autorizado: quantidadeAprovada > 0,
        };
      });
    },
  },
  created: function () {
    var index = 0;
    //this.readOnly = !getUserPermission(1);
    this.prioridade =
      this.requisicao.prioridade == 1 ? "Normal" : "Emergencial";
    this.id = this.requisicao.id;
    this.requisitante = this.requisicao.requisitante;
    this.idOrdemServico =
      this.requisicao.idOrdemServico == null ||
      this.requisicao.idOrdemServico == 0
        ? "NA"
        : this.requisicao.idOrdemServico;
    this.produtosL = JSON.parse(
      JSON.stringify(this.requisicao.produtos || [])
    );
    this.autorizado = this.requisicao.autorizado;
    this.unidadeAdm = this.requisicao.unidadeAdm;
    this.local = this.requisicao.local;
    this.observacao = this.requisicao.observacao;
    this.observacaoAprovador = this.requisicao.observacaoAutorizador;
    /*this.produtosL.forEach(
      (e) => (e["index"] = index++),
      (e["quantidadeAprovada"] = 0)
    );*/

    for (let i = 0; i < this.produtosL.length; i++) {
      this.$set(this.produtosL[i], "index", index++);
      this.$set(
        this.produtosL[i],
        "quantidadeAprovada",
        this.produtosL[i].quantidade
      );
      this.$set(this.produtosL[i], "autorizado", true);
    }
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
};
</script>
